'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomForm = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../../utils');

var _functional = require('../../utils/functional');

var _listeners = require('../../utils/listeners');

var _validation = require('../../utils/validation');

var _button = require('../button/button');

var _ = require('./');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-CustomForm';

var selectors = {
  FORM_FIELD: '.frm-Field'
};

var classes = {
  VALIDATION_CONTAINER: 'val-Validation',
  VALIDATION_CONTAINER_ERROR: 'val-Validation-error',
  VALIDATION_CONTAINER_SUCCESS: 'val-Validation-success',
  VALIDATION_TEXT: 'val-Validation_Text'

  /**
   * Component used to handle custom validations on different form fields
   *
   * @param {HTMLElement} el - The form element
   * @param {Object} config - The configuration object
   * @param {boolean} config.showLoading - If the submit button show show a loading state when the form has been submitted
   *
   * @description Basic implementation initialises all Form Field elements using the FormField class, all fields that are required will have validations run on them, if the validations fail, all fields that need to be updated will get highlighted, otherwise it means that the form is ready to be submitted using a callback function.
   */
};
var CustomForm = exports.CustomForm = function () {
  function CustomForm(el) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, CustomForm);

    this.el = el;
    this.els = this.getEls();
    this.config = (0, _assign2.default)({}, this.getConfig(), config);

    this.listeners = new _listeners.Listeners();
  }

  /**
   * Adds an event handler for the submit event
   *
   * @param {(error: string, data: Object)} cb - A callback that can execute after the form has been validated
   */

  (0, _createClass3.default)(CustomForm, [{
    key: 'onSubmit',
    value: function onSubmit(cb) {
      var _this2 = this;

      var _this = this;

      this.listeners.add(this.el, 'submit', function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(evt) {
          var error, data;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  evt.preventDefault();

                  if (_this2.config.showLoading) _this2.els.submitButton.setLoading(true);

                  _this.clearValidations();

                  error = !_this.validateForm();
                  data = _this.getFormData();
                  _context.next = 7;
                  return cb(error, data);

                case 7:

                  if (_this2.config.showLoading) _this2.els.submitButton.setLoading(false);

                case 8:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    /**
     * Removes all the content from all input fields and resets the validation state
     */

  }, {
    key: 'clearForm',
    value: function clearForm() {
      this.els.fields.forEach(function (field) {
        return field.reset();
      });
      this.clearValidations();
    }

    /**
     * Validates the form
     *
     * @returns {boolean} - If the form is valid or not
     */

  }, {
    key: 'validateForm',
    value: function validateForm() {
      var _this3 = this;

      var formIsValid = true;
      var validationMessages = [];
      var scrollTo = void 0;

      this.els.fields.forEach(function (field) {
        if (!field.required) return;

        if (field.value === '') {
          formIsValid = false;
          validationMessages.push(field.validationMessages.empty);
          field.setValidate(true);

          if (!scrollTo) {
            scrollTo = field.el;
          }
        } else if (field.type === 'email' && !(0, _validation.isValidEmail)(field.value)) {
          formIsValid = false;
          validationMessages.push(field.validationMessages.invalid);
          field.setValidate(true);

          if (!scrollTo) {
            scrollTo = field.el;
          }
        }
      });

      this.els.validationContainer.classList.toggle(classes.VALIDATION_CONTAINER, !formIsValid);
      this.els.validationContainer.classList.toggle(classes.VALIDATION_CONTAINER_ERROR, !formIsValid);
      validationMessages.forEach(function (message) {
        var messageEl = (0, _functional.createElement)('p', { class: classes.VALIDATION_TEXT });
        messageEl.innerHTML = message;
        _this3.els.validationContainer.appendChild(messageEl);
      });

      if (scrollTo) {
        (0, _utils.scrollToElem)(scrollTo, -40);
      }

      return formIsValid;
    }

    /**
     * Removes all validation messages and validation state from all fields
     */

  }, {
    key: 'clearValidations',
    value: function clearValidations() {
      this.els.validationContainer.classList.remove(classes.VALIDATION_CONTAINER);
      this.els.validationContainer.classList.remove(classes.VALIDATION_CONTAINER_ERROR);
      this.els.validationContainer.innerHTML = '';
      this.els.fields.forEach(function (field) {
        return field.setValidate(false);
      });
    }

    /**
     * Show's default error message
     *
     * @param {boolean} val
     */

  }, {
    key: 'showError',
    value: function showError(val) {
      this.els.validationContainer.classList.toggle(classes.VALIDATION_CONTAINER, val);
      this.els.validationContainer.classList.toggle(classes.VALIDATION_CONTAINER_ERROR, val);

      var errorMessage = (0, _functional.createElement)('p', { class: classes.VALIDATION_TEXT });
      errorMessage.innerHTML = this.config.errorMessage;
      this.els.validationContainer.appendChild(errorMessage);
    }

    /**
     * Returns an object with all of the Form's properties parsed, the key will be what's set as a name in the field element
     *
     * @returns {Object}
     */

  }, {
    key: 'getFormData',
    value: function getFormData() {
      var data = {};
      var formData = new FormData(this.el);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(formData.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2);

          var key = _ref3[0];
          var value = _ref3[1];

          data[key] = value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    }

    /**
     * Returns the configuration object from data attributes
     *
     * @returns {Object}
     */

  }, {
    key: 'getConfig',
    value: function getConfig() {
      var _el$dataset = this.el.dataset,
          preventDefault = _el$dataset.preventDefault,
          showLoading = _el$dataset.showLoading,
          errorMessage = _el$dataset.errorMessage;

      return {
        preventDefault: preventDefault,
        showLoading: showLoading,
        errorMessage: errorMessage
      };
    }

    /**
     * Gets all necessary elements from the DOM
     *
     * @returns {Object}
     */

  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        validationContainer: (0, _functional.getElement)('.' + MODULE_NAME + '_ValidationContainer', { context: context }),
        fields: (0, _functional.getElements)(selectors.FORM_FIELD, { context: context }).map(function (field) {
          return new _.FormField(field);
        }),
        submitButton: new _button.Button((0, _functional.getElement)('.' + MODULE_NAME + '_SubmitButton', { context: context }))
      };
    }
  }]);
  return CustomForm;
}();